import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { MessageSquareWarning } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Field, PageTitle, btnGhost, btnPrimary, inputCls } from "../components/ui";
import { COMPLAINT_STATUS, COMPLAINT_TYPE, Thread } from "./admin/AdminComplaints";

function Reply({ c, reload }) {
  const [msg, setMsg] = useState("");
  const send = async () => { try { await api.post(`/complaints/${c.id}/messages`, { message: msg }); setMsg(""); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return <div className="flex gap-2"><input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Acrescentar informação" className={inputCls} data-testid={`complaint-reply-${c.number}`} /><button disabled={msg.trim().length < 2} onClick={send} className={btnGhost} data-testid={`complaint-reply-btn-${c.number}`}>Enviar</button></div>;
}

export default function Complaints() {
  const [params] = useSearchParams();
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ subject_type: params.get("tipo") || "order", reference: params.get("ref") || "", title: "", message: "" });
  const load = () => api.get("/complaints/mine").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/complaints", f); toast.success(`Reclamação ${data.number} registada`); setF({ ...f, title: "", message: "" }); load(); } catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <div className="flex flex-col gap-5" data-testid="complaints-page">
      <PageTitle title="Reclamações" sub="Diga-nos o que correu mal. A equipa BÔ responde aqui e por email." />
      <form onSubmit={submit} className="bo-card grid gap-3 p-5 sm:grid-cols-2" data-testid="complaint-form">
        <Field label="Assunto"><select value={f.subject_type} onChange={set("subject_type")} className={inputCls} data-testid="complaint-type">{Object.entries(COMPLAINT_TYPE).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></Field>
        <Field label="Referência (nº da encomenda ou recarga)"><input value={f.reference} onChange={set("reference")} className={inputCls} data-testid="complaint-reference" /></Field>
        <div className="sm:col-span-2"><Field label="Título"><input required minLength={3} value={f.title} onChange={set("title")} className={inputCls} data-testid="complaint-title" /></Field></div>
        <div className="sm:col-span-2"><Field label="Descrição"><textarea required minLength={10} rows={4} value={f.message} onChange={set("message")} className={inputCls} data-testid="complaint-message" /></Field></div>
        <button className={`${btnPrimary} sm:col-span-2`} data-testid="complaint-submit-btn"><MessageSquareWarning className="h-4 w-4" />Enviar reclamação</button>
      </form>
      {items.map((c) => (
        <div key={c.id} className="bo-card flex flex-col gap-3 p-5" data-testid={`complaint-${c.number}`}>
          <p className="flex flex-wrap items-center gap-2 text-sm"><strong>{c.number}</strong>{c.title}<span className="ml-auto rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold" data-testid={`complaint-status-${c.number}`}>{COMPLAINT_STATUS[c.status]}</span></p>
          <Thread c={c} />
          {["open", "in_progress"].includes(c.status) && <Reply c={c} reload={load} />}
        </div>))}
    </div>
  );
}
